import { PlusOutlined } from '@ant-design/icons';
import { PrimaryButton, styleVariables, useLayoutContext } from '@lib/common';
import { Dropdown } from 'antd';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import styled from 'styled-components';

type CreateMenuItem = { key: string; label: string; icon?: ReactNode; onClick: () => void };

const StyledDropdownMenu = styled.div`
  width: 250px;
  border-radius: 8px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  border: 2px solid ${styleVariables.colors.gray9};
  background: #ffffff;
  overflow: hidden;
  .ant-dropdown-menu-item {
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 500;
    color: #4a4a4a;
    transition: all 0.2s ease;
    &:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #3366ff;
    }
    .anticon {
      font-size: 16px;
      color: inherit;
    }
  }
`;

export default function SiderNewDropdown({
  menuItems,
  forceCollapsed,
}: {
  menuItems: CreateMenuItem[];
  forceCollapsed?: boolean;
}) {
  const { collapsed: layoutCollapsed } = useLayoutContext();
  const collapsed = forceCollapsed ?? layoutCollapsed;
  const { t } = useTranslation('common');
  return (
    <Dropdown
      menu={{ items: menuItems, className: 'styled-dropdown-menu' }}
      trigger={['click']}
      placement="bottomLeft"
      dropdownRender={(menu) => <StyledDropdownMenu>{menu}</StyledDropdownMenu>}
    >
      <PrimaryButton
        type="primary"
        icon={<PlusOutlined />}
        aria-label={t('new')}
        title={t('new')}
        style={{
          width: '100%',
          ...(collapsed ? { justifyContent: 'center', padding: '0 8px' } : {}),
        }}
      >
        {!collapsed ? t('new') : undefined}
      </PrimaryButton>
    </Dropdown>
  );
}
